import _objectWithoutProperties2 from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { useContext, useState, useCallback, useMemo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTable, { ReactTableDefaults } from 'react-table';
import _ from 'lodash';
import { LocaleService, TranslatorContext, sortWithLocale } from '@jutro/locale';
import { intlMessageShape } from '@jutro/prop-types';
import { useBreakpoint } from '@jutro/layout';
import cx from 'classnames';
import { TransitionGroup } from 'react-transition-group';
import { Chevron, AnimationGroup, getKeyPressHandler, RadioButton, CheckboxField } from '@jutro/components';
import { logDeprecationMessage, uniqueInnerId } from '@jutro/platform';
import { error, warning } from '@jutro/logger';
import { Pagination } from './Pagination/Pagination';
import { SHOW_ALL_PAGES } from './Pagination/PageSizes';
import { TableBar } from './TableBar';
import { defaultColumnFilter } from './helper';
import { useExpansion } from './state/expansion/useExpansion';
import { useSelection } from './state/selection/useSelection';
import { useConfig } from './state/config/useConfig';
import { useAsync } from './state/async/useAsync';
import { useAccessibilityProps } from './accessibility/useAccessibilityProps';
import { TableContext } from './TableContext';
import { RadioColumn } from './columns/RadioColumn';
import { ActionColumn } from './columns/ActionColumn';
import { messages } from './DataTable.messages';
import styles from "./DataTable.module.css";
import 'react-table/react-table.css';
const nonConfigurableColumns = [RadioColumn, ActionColumn];
const textAlignMapping = {
  left: styles.textLeft,
  right: styles.textRight
};
const expanderDefaults = _objectSpread({}, ReactTableDefaults.expanderDefaults, {
  width: 28
});
const AnimatedTrGroupComponent = _ref => {
  let children = _ref.children,
    props = _objectWithoutProperties2(_ref, ["children"]);
  return React.createElement(ReactTableDefaults.TrGroupComponent, props, React.createElement(TransitionGroup, {
    component: null
  }, children));
};
const transitionGroupProps = ['onExited', 'in', 'appear', 'enter', 'exit'];
const AnimationResistantTrComponent = _ref2 => {
  let hasActions = _ref2.hasActions,
    props = _objectWithoutProperties2(_ref2, ["hasActions"]);
  const a11yProps = {};
  if (hasActions) {
    a11yProps.tabIndex = 0;
    a11yProps.role = 'button';
    a11yProps['aria-label'] = 'row';
  }
  return React.createElement(ReactTableDefaults.TrComponent, _extends({}, a11yProps, _.omit(props, transitionGroupProps)));
};
const splitHeaderText = text => React.createElement("span", {
  className: styles.headerMultiline
}, text);
const renderNull = () => null;
const ignoredClickTargets = ['INPUT', 'BUTTON', 'A', 'LABEL', 'SELECT', 'I'];
const handleNestedClick = (event, callback) => {
  const currentTarget = event.target;
  if (currentTarget && _includesInstanceProperty(ignoredClickTargets).call(ignoredClickTargets, currentTarget.tagName)) {
    return;
  }
  callback(event);
};
const isEnabledColumn = (config = {}) => {
  var _config$enabled;
  return (_config$enabled = config.enabled) !== null && _config$enabled !== void 0 ? _config$enabled : true;
};
const findById = id => ({
  id: configId
}) => id === configId;
const orderColumnsUsingConfig = config => (columnA, columnB) => {
  const aInitialIndex = _findIndexInstanceProperty(config).call(config, findById(columnA.props.id));
  const bInitialIndex = _findIndexInstanceProperty(config).call(config, findById(columnB.props.id));
  if (aInitialIndex === -1 || bInitialIndex === -1) {
    return 0;
  }
  return aInitialIndex - bInitialIndex;
};
const getAsyncParams = params => _.pick(params, ['page', 'pageSize', 'sorted', 'filterValue']);
const dataTableConfigColumnsShape = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired
}));
const dataTableConfigColumnsSortedShape = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  desc: PropTypes.bool.isRequired
}));
const dataTableConfigShape = PropTypes.shape({
  editedRow: PropTypes.number,
  columns: dataTableConfigColumnsShape,
  filterValue: PropTypes.string,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  sorted: dataTableConfigColumnsSortedShape
});
const rowIdShape = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
const dataTablePropTypes = {
  id: PropTypes.string.isRequired,
  showSearch: PropTypes.bool,
  showPagination: PropTypes.bool,
  config: dataTableConfigShape,
  defaultConfig: dataTableConfigShape,
  onConfigChange: PropTypes.func,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  data: PropTypes.arrayOf(PropTypes.object),
  onFilter: PropTypes.func,
  onColumnFilter: PropTypes.func,
  filterPlaceholder: intlMessageShape,
  children: PropTypes.node.isRequired,
  expandable: PropTypes.bool,
  multipleRowsExpandable: PropTypes.bool,
  renderExpanderContent: PropTypes.func,
  headerMultiline: PropTypes.bool,
  onRowClick: PropTypes.func,
  expandOnRowClick: PropTypes.bool,
  selectOnRowClick: PropTypes.bool,
  selectionType: PropTypes.oneOf(['none', 'single', 'multi']),
  selectedRows: PropTypes.arrayOf(rowIdShape),
  selectionActions: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired
  })),
  onSelectionChange: PropTypes.func,
  columnsConfigurable: PropTypes.bool,
  loadingText: intlMessageShape,
  noDataText: intlMessageShape,
  localSorting: PropTypes.bool,
  phone: PropTypes.object,
  phoneWide: PropTypes.object,
  tablet: PropTypes.object,
  onSaveRow: PropTypes.func,
  onEditCancel: PropTypes.func,
  onEditStart: PropTypes.func,
  path: PropTypes.string,
  onFetchData: PropTypes.func,
  onGetRowId: PropTypes.func,
  rowIdPath: PropTypes.string,
  tableLabel: intlMessageShape,
  numberOfRows: PropTypes.number
};
export const DataTable = dataTableProps => {
  const _useBreakpoint = useBreakpoint(dataTableProps),
    breakpointProps = _useBreakpoint.breakpointProps,
    applyBreakpoint = _useBreakpoint.applyBreakpoint,
    breakpoint = _useBreakpoint.breakpoint;
  const id = breakpointProps.id,
    showSearch = breakpointProps.showSearch,
    showPagination = breakpointProps.showPagination,
    pageSizeOptions = breakpointProps.pageSizeOptions,
    syncData = breakpointProps.data,
    onFilter = breakpointProps.onFilter,
    onColumnFilter = breakpointProps.onColumnFilter,
    defaultConfig = breakpointProps.defaultConfig,
    config = breakpointProps.config,
    filterPlaceholder = breakpointProps.filterPlaceholder,
    children = breakpointProps.children,
    onConfigChange = breakpointProps.onConfigChange,
    onSaveRow = breakpointProps.onSaveRow,
    onEditCancel = breakpointProps.onEditCancel,
    onEditStart = breakpointProps.onEditStart,
    expandable = breakpointProps.expandable,
    multipleRowsExpandable = breakpointProps.multipleRowsExpandable,
    renderExpanderContent = breakpointProps.renderExpanderContent,
    basePath = breakpointProps.path,
    headerMultiline = breakpointProps.headerMultiline,
    onRowClick = breakpointProps.onRowClick,
    expandOnRowClick = breakpointProps.expandOnRowClick,
    selectOnRowClick = breakpointProps.selectOnRowClick,
    selectionType = breakpointProps.selectionType,
    onGetRowIdProp = breakpointProps.onGetRowId,
    rowIdPath = breakpointProps.rowIdPath,
    selectedRows = breakpointProps.selectedRows,
    selectionActions = breakpointProps.selectionActions,
    onSelectionChange = breakpointProps.onSelectionChange,
    onFetchData = breakpointProps.onFetchData,
    columnsConfigurable = breakpointProps.columnsConfigurable,
    loadingText = breakpointProps.loadingText,
    noDataText = breakpointProps.noDataText,
    localSorting = breakpointProps.localSorting,
    tableLabel = breakpointProps.tableLabel,
    numberOfRowsProp = breakpointProps.numberOfRows;
  const onGetRowId = useMemo(() => rowIdPath ? row => row[rowIdPath] : onGetRowIdProp, [onGetRowIdProp, rowIdPath]);
  const childrenArray = React.Children.toArray(children);
  const reactTable = useRef();
  const shouldShowSearch = showSearch !== false;
  const shouldShowPagination = showPagination !== false;
  const shouldBeExpandable = expandable && !!renderExpanderContent;
  const shouldBeSelectable = selectionType !== 'none';
  const translator = useContext(TranslatorContext);
  const language = LocaleService.getStoredLanguage();
  const _useExpansion = useExpansion(),
    _useExpansion2 = _slicedToArray(_useExpansion, 2),
    expandedRows = _useExpansion2[0],
    _useExpansion2$ = _useExpansion2[1],
    collapse = _useExpansion2$.collapse,
    toggleExpansion = _useExpansion2$.toggle,
    collapseAll = _useExpansion2$.collapseAll;
  const _useSelection = useSelection({
      all: false,
      rows: selectedRows || []
    }, selectedRows, selectionType, onSelectionChange),
    _useSelection2 = _slicedToArray(_useSelection, 2),
    selectedState = _useSelection2[0],
    _useSelection2$ = _useSelection2[1],
    selectRow = _useSelection2$.select,
    toggleSelection = _useSelection2$.toggle,
    setAll = _useSelection2$.setAll,
    clearAll = _useSelection2$.clearAll;
  const _useAsync = useAsync(),
    _useAsync2 = _slicedToArray(_useAsync, 2),
    _useAsync2$ = _useAsync2[0],
    asyncData = _useAsync2$.asyncData,
    loading = _useAsync2$.loading,
    totalNumberOfRows = _useAsync2$.numberOfRows,
    asyncActions = _useAsync2[1];
  const data = onFetchData ? asyncData : syncData;
  const getEditProps = rowId => rowId !== undefined ? {
    rowId,
    row: _findInstanceProperty(data).call(data, (row, index) => onGetRowId(row, index) === rowId)
  } : {};
  const _useState = useState(getEditProps((config === null || config === void 0 ? void 0 : config.editedRow) || defaultConfig.editedRow)),
    _useState2 = _slicedToArray(_useState, 2),
    editProps = _useState2[0],
    setEditProps = _useState2[1];
  const updateEditedRow = rowId => setEditProps(getEditProps(rowId));
  const initialColumnsConfig = useMemo(() => {
    var _config$columns, _context;
    const initialConfig = (_config$columns = config === null || config === void 0 ? void 0 : config.columns) !== null && _config$columns !== void 0 ? _config$columns : defaultConfig.columns;
    const withInitialConfig = initialConfig === null || initialConfig === void 0 ? void 0 : initialConfig.length;
    if (!childrenArray.length) {
      return [];
    }
    if (withInitialConfig) {
      _sortInstanceProperty(childrenArray).call(childrenArray, orderColumnsUsingConfig(initialConfig));
    }
    return _filterInstanceProperty(_context = _mapInstanceProperty(childrenArray).call(childrenArray, childColumn => {
      const columnChildId = childColumn.props.id,
        type = childColumn.type;
      if (_includesInstanceProperty(nonConfigurableColumns).call(nonConfigurableColumns, type)) {
        return undefined;
      }
      const columnConfig = {
        id: columnChildId,
        enabled: true
      };
      if (withInitialConfig) {
        const initialColumnConfig = _findInstanceProperty(initialConfig).call(initialConfig, ({
          id: configId
        }) => columnChildId === configId);
        columnConfig.enabled = isEnabledColumn(initialColumnConfig);
      }
      return columnConfig;
    })).call(_context, Boolean);
  }, [childrenArray, config, defaultConfig]);
  const _useConfig = useConfig(_objectSpread({}, defaultConfig, {
      columns: initialColumnsConfig
    }), config && (() => {
      if (config.editedRow !== (editProps === null || editProps === void 0 ? void 0 : editProps.rowId)) {
        updateEditedRow(config.editedRow);
      }
      return _objectSpread({}, config, {
        columns: initialColumnsConfig
      });
    }), onConfigChange),
    _useConfig2 = _slicedToArray(_useConfig, 2),
    _useConfig2$ = _useConfig2[0],
    filterValue = _useConfig2$.filterValue,
    pageSizeSelectedOption = _useConfig2$.pageSize,
    page = _useConfig2$.page,
    sorted = _useConfig2$.sorted,
    columns = _useConfig2$.columns,
    editedRow = _useConfig2$.editedRow,
    _useConfig2$2 = _useConfig2[1],
    setFilterValue = _useConfig2$2.setFilterValue,
    setPageSize = _useConfig2$2.setPageSize,
    setPage = _useConfig2$2.setPage,
    setSorted = _useConfig2$2.setSorted,
    setColumns = _useConfig2$2.setColumns,
    setEditedRow = _useConfig2$2.setEditedRow;
  const _useAccessibilityProp = useAccessibilityProps({
      selectionType,
      isExpandable: expandable && renderExpanderContent,
      tableId: id,
      sorted,
      tableLabel: translator(tableLabel)
    }),
    getA11yTrGroupProps = _useAccessibilityProp.getA11yTrGroupProps,
    getA11yTrProps = _useAccessibilityProp.getA11yTrProps,
    getA11yTableProps = _useAccessibilityProp.getA11yTableProps,
    getA11yTheadThPropsHeader = _useAccessibilityProp.getA11yTheadThPropsHeader,
    getA11yTheadThPropsSortableHeader = _useAccessibilityProp.getA11yTheadThPropsSortableHeader,
    getA11yTdProps = _useAccessibilityProp.getA11yTdProps;
  const isEdited = useCallback(rowId => editedRow === rowId, [editedRow]);
  const editActions = {
    start: (row, index) => {
      const rowId = onGetRowId(row, index);
      if (onEditStart) {
        onEditStart(row, rowId);
      }
      setEditedRow(rowId);
      updateEditedRow(rowId);
      collapse(rowId);
    },
    update: (_row, path, newValue) => {
      setEditProps(oldEditProps => _objectSpread({}, oldEditProps, {
        row: _objectSpread({}, oldEditProps.row, {
          [path]: newValue
        })
      }));
    },
    cancel: () => {
      if (onEditCancel) {
        onEditCancel(editProps.row, editProps.rowId);
      }
      setEditedRow();
      updateEditedRow();
    },
    save: () => {
      if (onSaveRow) {
        onSaveRow(editProps.row, editProps.rowId);
      }
      setEditedRow();
      updateEditedRow();
    }
  };
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pressedRowId = _useState4[0],
    setPressedRowId = _useState4[1];
  const handleExpand = useCallback((rowId, viewIndex) => !isEdited(rowId) && toggleExpansion(rowId, viewIndex, multipleRowsExpandable), [isEdited, multipleRowsExpandable, toggleExpansion]);
  const filterFunction = useMemo(() => {
    if (onFilter) {
      return onFilter;
    }
    return value => {
      const valueFilters = _mapInstanceProperty(childrenArray).call(childrenArray, ({
        props
      }) => (props.onFilter || onColumnFilter)(value, props));
      return (item, index, tableData) => _someInstanceProperty(valueFilters).call(valueFilters, valueFilter => valueFilter(item, index, tableData));
    };
  }, [onFilter, childrenArray, onColumnFilter]);
  const contextColumnsConfig = useMemo(() => _mapInstanceProperty(columns).call(columns, columnConfig => {
    const childColumn = _findInstanceProperty(childrenArray).call(childrenArray, ({
      props: {
        id: columnChildId
      }
    }) => columnConfig.id === columnChildId);
    return _objectSpread({}, columnConfig, {
      header: childColumn.props.header
    });
  }), [childrenArray, columns]);
  const tableContext = useMemo(() => ({
    styles,
    columns: _objectSpread({
      configurable: columnsConfigurable,
      config: contextColumnsConfig
    }, columnsConfigurable && {
      setConfig: setColumns
    })
  }), [columnsConfigurable, contextColumnsConfig, setColumns]);
  const filteredData = useMemo(() => {
    if (!data || !children) return [];
    return shouldShowSearch && filterValue ? _filterInstanceProperty(data).call(data, filterFunction(filterValue)) : data;
  }, [shouldShowSearch, data, children, filterFunction, filterValue]);
  const numberOfRows = onFetchData ? totalNumberOfRows : numberOfRowsProp || filteredData.length;
  const pageSize = useMemo(() => !shouldShowPagination || pageSizeSelectedOption === SHOW_ALL_PAGES ? numberOfRows : pageSizeSelectedOption, [shouldShowPagination, pageSizeSelectedOption, numberOfRows]);
  const Expander = useCallback(({
    isExpanded,
    row,
    index,
    viewIndex
  }) => React.createElement(Chevron, {
    isOpen: isExpanded,
    className: styles.expanderIcon,
    tabIndex: "0",
    role: "button",
    messageProps: {
      label: !isExpanded ? messages.collapsedRowLabel : messages.expandedRowLabel
    },
    onMouseDown: event => {
      event.preventDefault();
    },
    onKeyPress: getKeyPressHandler(() => toggleExpansion(onGetRowId(row, index), viewIndex, multipleRowsExpandable))
  }), [toggleExpansion, multipleRowsExpandable, onGetRowId]);
  const getExpandRowActions = useCallback(({
    index,
    viewIndex,
    row
  }) => shouldBeExpandable && expandOnRowClick && (() => handleExpand(onGetRowId(row, index), viewIndex)), [expandOnRowClick, handleExpand, shouldBeExpandable, onGetRowId]);
  const SelectionHeader = useMemo(() => {
    if (selectionType !== 'multi') {
      return undefined;
    }
    return () => React.createElement(CheckboxField, {
      id: "".concat(id, "-select-all"),
      onValueChange: value => {
        if (value) {
          var _context2;
          const allRows = reactTable.current.getResolvedState().sortedData;
          const startIndex = page * pageSize;
          const visibleRows = _mapInstanceProperty(_context2 = _sliceInstanceProperty(allRows).call(allRows, startIndex, startIndex + pageSize)).call(_context2, ({
            _original,
            _index
          }) => onGetRowId(_original, _index));
          setAll(visibleRows);
        } else {
          clearAll();
        }
      },
      value: selectedState.all
    });
  }, [id, pageSize, page, selectionType, selectedState.all, clearAll, setAll, onGetRowId]);
  const SelectionCell = useMemo(() => {
    if (selectionType === 'none') {
      return undefined;
    }
    if (selectionType === 'single') {
      return ({
        index,
        viewIndex,
        original: row
      }) => {
        const rowId = onGetRowId(row, index);
        return React.createElement(RadioButton, {
          id: "".concat(id, "-select-").concat(viewIndex),
          option: {
            code: rowId
          },
          onValueChange: () => selectRow(rowId),
          value: "".concat(selectedState.rows[0]),
          className: styles.radio,
          tabIndex: "0"
        });
      };
    }
    return ({
      index,
      viewIndex,
      original: row
    }) => {
      var _context3;
      const rowId = onGetRowId(row, index);
      return React.createElement(CheckboxField, {
        id: "".concat(id, "-select-").concat(viewIndex),
        onValueChange: () => toggleSelection(rowId),
        value: _includesInstanceProperty(_context3 = selectedState.rows).call(_context3, rowId)
      });
    };
  }, [id, selectionType, selectedState.rows, selectRow, toggleSelection, onGetRowId]);
  const shouldDisableActions = selectedState.rows.length > 1;
  const columnsArray = useMemo(() => {
    var _context5;
    let visibleColumns = childrenArray;
    if (columns !== null && columns !== void 0 && columns.length) {
      var _context4;
      visibleColumns = _sortInstanceProperty(_context4 = _filterInstanceProperty(visibleColumns).call(visibleColumns, ({
        props: {
          id: colId
        }
      }) => {
        var _columnConfig$enabled;
        const columnConfig = _findInstanceProperty(columns).call(columns, ({
          id: configId
        }) => colId === configId);
        return (_columnConfig$enabled = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.enabled) !== null && _columnConfig$enabled !== void 0 ? _columnConfig$enabled : true;
      })).call(_context4, orderColumnsUsingConfig(columns));
    }
    const childrenColumns = _mapInstanceProperty(visibleColumns).call(visibleColumns, ({
      props,
      type
    }, columnIndex) => {
      const _applyBreakpoint = applyBreakpoint(props),
        cell = _applyBreakpoint.cell,
        renderCell = _applyBreakpoint.renderCell,
        renderEditCell = _applyBreakpoint.renderEditCell,
        getRowActions = _applyBreakpoint.getRowActions,
        columnClassName = _applyBreakpoint.columnClassName,
        rest = _objectWithoutProperties(_applyBreakpoint, ["cell", "renderCell", "renderEditCell", "getRowActions", "columnClassName"]);
      const childId = rest.id,
        header = rest.header,
        renderHeader = rest.renderHeader,
        textAlign = rest.textAlign,
        visible = rest.visible,
        headerClassName = rest.headerClassName,
        cellClassName = rest.cellClassName,
        columnProportion = rest.columnProportion,
        width = rest.width,
        sortable = rest.sortable,
        readOnly = rest.readOnly,
        editCellClass = rest.editCellClass,
        path = rest.path,
        onSort = rest.onSort,
        onAccessor = rest.onAccessor;
      if ((type === null || type === void 0 ? void 0 : type.name) === 'MoneyColumn') {
        logDeprecationMessage('MoneyColumn', 'DisplayColumn with [fieldDatatype="currency"]', undefined, '6.0.0');
      }
      const cellCallback = cell || renderCell;
      const editCellCallback = renderEditCell;
      const propsToCallback = _objectSpread({}, rest, {
        basePath,
        translator,
        disableActions: shouldDisableActions,
        breakpoint
      });
      const Cell = cellCallback && (({
        original,
        index
      }) => {
        const rowId = onGetRowId(original, index);
        if (!readOnly && editCellCallback && isEdited(rowId)) {
          return editCellCallback({
            props: propsToCallback,
            editProps: _objectSpread({}, editProps, {
              index
            }),
            editActions
          });
        }
        return cellCallback(original, rowId, propsToCallback, editActions.start);
      });
      const headerText = translator(header);
      const headerFunction = renderHeader || (headerMultiline ? splitHeaderText : _.identity);
      const columnType = (type === null || type === void 0 ? void 0 : type.name) === 'ActionColumn' ? 'actions' : 'display';
      return {
        id: childId || columnIndex,
        type: columnType,
        Header: () => headerFunction(headerText),
        Cell,
        className: cx(textAlignMapping[textAlign], columnClassName, cellClassName),
        headerClassName: cx(textAlignMapping[textAlign], {
          [styles.headerOneLine]: !headerMultiline
        }, headerClassName),
        show: visible === undefined ? true : visible,
        minWidth: columnProportion,
        width,
        sortable,
        readOnly,
        editCellClass,
        textAlign,
        accessor: onAccessor || path,
        header: headerText,
        getRowActions,
        props: rest,
        sortMethod: onSort
      };
    });
    const selectionClassName = cx(styles.selectionCell, {
      [styles.serviceCell]: shouldBeExpandable
    });
    const selectionWidth = 44;
    const expanderClassName = cx(styles.expanderCell, {
      [styles.serviceCell]: shouldBeSelectable
    });
    const expanderWidth = 28;
    const serviceColumns = _filterInstanceProperty(_context5 = [shouldBeSelectable && {
      id: 'selection',
      type: "".concat(selectionType, "_selection"),
      Header: SelectionHeader,
      Cell: SelectionCell,
      sortable: false,
      resizable: false,
      minWidth: selectionWidth,
      width: selectionWidth,
      textAlign: 'center',
      headerClassName: selectionClassName,
      className: selectionClassName
    }, shouldBeExpandable && {
      id: 'expander',
      type: 'expander',
      expander: true,
      readOnly: true,
      getRowActions: getExpandRowActions,
      Expander,
      className: expanderClassName,
      isEdited,
      width: expanderWidth,
      minWidth: expanderWidth
    }]).call(_context5, Boolean);
    return _concatInstanceProperty(serviceColumns).call(serviceColumns, childrenColumns);
  }, [childrenArray, columns, shouldBeExpandable, shouldBeSelectable, SelectionHeader, SelectionCell, getExpandRowActions, Expander, isEdited, applyBreakpoint, basePath, shouldDisableActions, breakpoint, translator, headerMultiline, editActions, editProps, onGetRowId]);
  const getTrProps = useCallback((item, row) => {
    var _context6, _context7;
    const rowColumns = item.columns;
    const original = row.original,
      index = row.index,
      viewIndex = row.viewIndex;
    const rowClickAction = onRowClick && (event => onRowClick(original, index, event));
    const availableActions = _filterInstanceProperty(_context6 = _.flatten([rowClickAction, ..._mapInstanceProperty(rowColumns).call(rowColumns, ({
      getRowActions,
      props
    }) => getRowActions && getRowActions({
      row: original,
      index,
      viewIndex,
      props,
      onEditStart: editActions.start,
      selectOnRowClick,
      expandOnRowClick
    }))])).call(_context6, Boolean);
    const rowId = onGetRowId(original, index);
    const hasActions = availableActions.length;
    const isRowPressed = pressedRowId === rowId;
    const isRowSelected = _includesInstanceProperty(_context7 = selectedState.rows).call(_context7, rowId);
    const isRowEdited = isEdited(rowId);
    const actionsHandler = event => {
      if (event.target === event.currentTarget) {
        event.preventDefault();
      }
      _forEachInstanceProperty(availableActions).call(availableActions, action => handleNestedClick(event, action));
    };
    const getRowPressHandler = callback => event => {
      if (event.key !== ' ' && event.key !== 'Enter') {
        return;
      }
      handleNestedClick(event, callback);
    };
    const props = _objectSpread({
      hasActions,
      className: cx(styles.tableRow, {
        [styles.clickableRow]: hasActions,
        [styles.activeRow]: isRowPressed,
        [styles.selectedRow]: isRowSelected,
        [styles.editedRow]: isRowEdited
      })
    }, getA11yTrProps());
    if (hasActions) {
      props.onClick = actionsHandler;
      props.onKeyPress = getRowPressHandler(actionsHandler);
      props.onKeyDown = getRowPressHandler(() => pressedRowId !== rowId && setPressedRowId(rowId));
      props.onKeyUp = getRowPressHandler(() => setPressedRowId(null));
    }
    return props;
  }, [editActions.start, expandOnRowClick, onRowClick, pressedRowId, selectOnRowClick, selectedState.rows, onGetRowId, getA11yTrProps, isEdited]);
  const getTdProps = useCallback((state, row, {
    readOnly,
    textAlign,
    editCellClass,
    type,
    id: columnId
  }) => {
    const index = row.index,
      viewIndex = row.viewIndex,
      original = row.original;
    const rowId = onGetRowId(original, index);
    const edited = isEdited(rowId);
    const isExpander = type === 'expander';
    const shouldBeFocusable = type !== 'display';
    return _objectSpread({
      className: cx(styles.tableCell, {
        [editCellClass]: editCellClass && !readOnly && edited,
        [styles.rightAlignCell]: textAlign === 'right',
        disabled: isExpander && edited
      }),
      onClick: isExpander && (() => handleExpand(rowId, viewIndex))
    }, getA11yTdProps(state, row, columnId, shouldBeFocusable));
  }, [isEdited, handleExpand, onGetRowId, getA11yTdProps]);
  const getHeaderCellProps = useCallback((_props, _columnInfo, column) => {
    const sortable = column.sortable === undefined || column.sortable;
    const sharedProps = {
      className: cx(styles.tableHeaderCell, {
        [styles.unsortedHeaderCell]: !sortable
      }),
      title: column.header
    };
    if (sortable) {
      return _objectSpread({}, sharedProps, {}, getA11yTheadThPropsSortableHeader(_props, column.id, column.type));
    }
    return _objectSpread({}, sharedProps, {
      pointerEvents: 'none'
    }, getA11yTheadThPropsHeader(_props, column.id, column.type));
  }, [getA11yTheadThPropsSortableHeader, getA11yTheadThPropsHeader]);
  const defaultSortMethod = useCallback((a, b) => {
    const sortingFunction = sortWithLocale(language);
    return sortingFunction(normalize(a), normalize(b));
  }, [language]);
  const tbodyProps = numberOfRows === 0 && {
    TbodyComponent: () => React.createElement("div", {
      className: styles.noDataMessage
    }, translator(noDataText))
  };
  const handleAsyncDataChange = useCallback(async asyncConfigs => {
    var _reactTable$current;
    const setAsyncData = asyncActions.setAsyncData,
      setLoading = asyncActions.setLoading;
    const reactTableState = reactTable === null || reactTable === void 0 ? void 0 : (_reactTable$current = reactTable.current) === null || _reactTable$current === void 0 ? void 0 : _reactTable$current.state;
    const asyncParams = _objectSpread({}, getAsyncParams(reactTableState), {}, getAsyncParams(asyncConfigs));
    try {
      setLoading(true);
      const fetchedData = await onFetchData(asyncParams);
      setAsyncData(fetchedData.rows, fetchedData.numberOfRows);
    } catch (err) {
      error("Failed to fetch data, ".concat(err));
    } finally {
      setLoading(false);
    }
  }, [asyncActions, onFetchData]);
  const debounceFilter = useCallback(_.debounce(newFilterValue => {
    handleAsyncDataChange({
      filterValue: newFilterValue,
      page: 0
    });
  }, 500), [handleAsyncDataChange]);
  const modeProps = onFetchData ? {
    data,
    loading,
    filterValue,
    loadingText: translator(loadingText)
  } : {
    sorted,
    defaultSortMethod,
    page
  };
  const isSortedOnServer = onFetchData && !localSorting;
  const isControlledMode = !onFetchData && numberOfRowsProp !== undefined;
  const handleSortedChange = useCallback(newSortedValue => {
    setSorted(newSortedValue, isSortedOnServer || isControlledMode);
    collapseAll();
    if (isSortedOnServer) {
      handleAsyncDataChange({
        sorted: newSortedValue,
        page: 0
      });
    }
  }, [setSorted, isSortedOnServer, collapseAll, handleAsyncDataChange]);
  const handlePageChange = useCallback(newPage => {
    setPage(newPage);
    collapseAll();
    if (onFetchData) {
      handleAsyncDataChange({
        page: newPage
      });
    }
  }, [setPage, collapseAll, onFetchData, handleAsyncDataChange]);
  const getPaginationComponent = useCallback(() => {
    const _uniqueInnerId = uniqueInnerId(id, 'paginationId'),
      paginationId = _uniqueInnerId.paginationId;
    const handleSelectPageSizeChange = value => {
      const newPageSize = value === SHOW_ALL_PAGES ? value : Number(value);
      setPageSize(newPageSize, true);
      collapseAll();
      if (onFetchData) {
        handleAsyncDataChange({
          page: 0,
          pageSize: newPageSize
        });
      }
    };
    return React.createElement(Pagination, {
      id: "".concat(paginationId, "_pagination"),
      numberOfRows: numberOfRows,
      pageSize: pageSize,
      pageSizeOptions: pageSizeOptions,
      pageSizeSelectedOption: pageSizeSelectedOption,
      onSelectPageSizeChange: handleSelectPageSizeChange,
      page: page,
      onPageChange: handlePageChange,
      canNext: page < Math.ceil(numberOfRows / pageSize) - 1,
      canPrevious: page !== 0
    });
  }, [collapseAll, handleAsyncDataChange, handlePageChange, id, numberOfRows, onFetchData, page, pageSize, pageSizeOptions, pageSizeSelectedOption, setPageSize]);
  const paginationProps = shouldShowPagination && numberOfRows > 0 ? {
    defaultPageSize: defaultConfig.pageSize,
    PaginationComponent: getPaginationComponent
  } : {
    showPagination: false,
    pageSize: numberOfRows
  };
  const expanderContentWrapper = useCallback(({
    original: rowData
  }) => {
    const expanderContentWrapperStyles = cx(styles.expandableRowWrapper, styles.expandableRow);
    return React.createElement(AnimationGroup, {
      animation: "expand",
      appear: true,
      in: true
    }, React.createElement("div", {
      className: expanderContentWrapperStyles
    }, renderExpanderContent(rowData)));
  }, [renderExpanderContent]);
  const subComponent = shouldBeExpandable ? expanderContentWrapper : null;
  const renderTableBar = useCallback(() => {
    const handleFilterChange = newFilterValue => {
      setFilterValue(newFilterValue, true);
      if (onFetchData) {
        debounceFilter(newFilterValue);
      }
      collapseAll();
    };
    const actions = selectionActions === null || selectionActions === void 0 ? void 0 : _mapInstanceProperty(selectionActions).call(selectionActions, _ref3 => {
      let _callback = _ref3.callback,
        rest = _objectWithoutProperties2(_ref3, ["callback"]);
      return _objectSpread({}, rest, {
        callback: () => {
          _callback(selectedState.rows);
          clearAll();
        }
      });
    });
    return React.createElement(TableContext.Provider, {
      value: tableContext
    }, React.createElement(TableBar, {
      filterValue: filterValue,
      onFilterChange: handleFilterChange,
      filterPlaceholder: translator(filterPlaceholder),
      selectionActions: actions,
      showSelectionActions: !!selectedState.rows.length,
      disabled: loading
    }));
  }, [debounceFilter, filterPlaceholder, filterValue, clearAll, loading, onFetchData, selectedState.rows, selectionActions, setFilterValue, tableContext, translator, collapseAll]);
  const reactTableKey = "".concat(id, "_").concat(onFetchData ? 'async' : 'sync');
  const getStyleProps = useCallback(() => _.mapValues({
    getTheadProps: styles.tableHeader,
    getTbodyProps: styles.tableBody,
    getTrGroupProps: styles.tableRowGroup
  }, className => () => _objectSpread({
    className
  }, getA11yTrGroupProps())), [getA11yTrGroupProps]);
  useEffect(() => {
    if (!onFetchData && numberOfRowsProp === undefined) {
      const isFirstPage = page === 0;
      const isLastPage = page === Math.floor(filteredData.length / pageSize);
      const isPageEmpty = isLastPage && filteredData.length % pageSize === 0;
      if (!isFirstPage && isPageEmpty) {
        setPage(page - 1);
      }
    }
  }, [pageSize, page, onFetchData, setPage, filteredData, numberOfRowsProp]);
  useEffect(() => {
    if (onFetchData) {
      if (syncData || numberOfRowsProp) {
        warning('The props `data` and `numberOfRows` will not be used when `onFetchData` prop is provided');
      }
      handleAsyncDataChange(defaultConfig);
    }
  }, [handleAsyncDataChange, onFetchData, syncData, numberOfRowsProp, defaultConfig]);
  return React.createElement("div", {
    id: id,
    className: styles.dataTable
  }, shouldShowSearch && renderTableBar(), React.createElement(ReactTable, _extends({
    key: reactTableKey,
    ref: reactTable,
    data: filteredData,
    columns: columnsArray,
    getTheadThProps: getHeaderCellProps,
    minRows: 0,
    styles: styles,
    className: cx(styles.reactTable, '-striped', '-highlight'),
    SubComponent: subComponent,
    expanded: expandedRows
  }, paginationProps, getStyleProps(), tbodyProps, {
    getTdProps: getTdProps,
    getTrProps: getTrProps,
    getTheadTrProps: getA11yTrProps,
    getTableProps: () => getA11yTableProps,
    NoDataComponent: renderNull,
    expanderDefaults: expanderDefaults,
    TrGroupComponent: AnimatedTrGroupComponent,
    TrComponent: AnimationResistantTrComponent,
    defaultSorted: defaultConfig.sorted,
    pageSize: pageSize,
    onPageChange: handlePageChange,
    onSortedChange: handleSortedChange
  }, modeProps, {
    manual: isSortedOnServer || isControlledMode
  })));
};
DataTable.propTypes = dataTablePropTypes;
DataTable.defaultProps = {
  showSearch: true,
  showPagination: true,
  defaultConfig: {
    filterValue: '',
    page: 0,
    pageSize: 10
  },
  onColumnFilter: defaultColumnFilter,
  pageSizeOptions: [10, 25, 50],
  expandable: true,
  multipleRowsExpandable: true,
  headerMultiline: false,
  selectionType: 'none',
  columnsConfigurable: true,
  noDataText: messages.noDataText,
  loadingText: messages.loadingText,
  localSorting: false,
  onGetRowId: (row, index) => index,
  tableLabel: messages.tableLabel,
  filterPlaceholder: messages.searchPlaceholder
};
function normalize(value) {
  if (value === null || value === undefined) {
    return '';
  }
  return value;
}
AnimatedTrGroupComponent.__docgenInfo = {
  componentName: "AnimatedTrGroupComponent",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "AnimatedTrGroupComponent",
  methods: [],
  actualName: "AnimatedTrGroupComponent"
};
AnimationResistantTrComponent.__docgenInfo = {
  componentName: "AnimationResistantTrComponent",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "AnimationResistantTrComponent",
  methods: [],
  actualName: "AnimationResistantTrComponent"
};
splitHeaderText.__docgenInfo = {
  componentName: "splitHeaderText",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "splitHeaderText",
  methods: [],
  actualName: "splitHeaderText"
};
DataTable.__docgenInfo = {
  componentName: "DataTable",
  packageName: "@jutro/datatable",
  description: "Component for displaying tabular data",
  displayName: "DataTable",
  methods: [],
  actualName: "DataTable",
  metadataType: "container",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify the component"
    },
    showSearch: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Defines whether search bar should be shown",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    showPagination: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Defines whether pagination should be shown or not",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    config: {
      type: {
        name: "custom",
        raw: "dataTableConfigShape"
      },
      required: false,
      description: "Used to set data table config. Use it together with onConfigChange to control data table from outside.\nIt includes sorting method, filtering value, page, page size, edited row and columns sorting"
    },
    defaultConfig: {
      type: {
        name: "custom",
        raw: "dataTableConfigShape"
      },
      required: false,
      description: "The configuration applied only on component initialization.\nIt includes sorting method, filtering value, page, page size, edited row and columns sorting",
      defaultValue: {
        value: "{\n    filterValue: '',\n    page: 0,\n    pageSize: 10,\n}",
        computed: false
      }
    },
    onConfigChange: {
      type: {
        name: "func"
      },
      required: false,
      description: "Function to call after config value changes. New config value is passed as argument. It includes sorting method, filtering value, page, page size and columns visibility"
    },
    pageSizeOptions: {
      type: {
        name: "arrayOf",
        value: {
          name: "number"
        }
      },
      required: false,
      description: "List of page size options",
      defaultValue: {
        value: "[10, 25, 50]",
        computed: false
      }
    },
    data: {
      type: {
        name: "arrayOf",
        value: {
          name: "object"
        }
      },
      required: false,
      description: "Cells data"
    },
    onFilter: {
      type: {
        name: "func"
      },
      required: false,
      description: "Predicate function for searching data"
    },
    onColumnFilter: {
      type: {
        name: "func"
      },
      required: false,
      description: "Predicate function for searching data per column",
      defaultValue: {
        value: "defaultColumnFilter",
        computed: true
      }
    },
    filterPlaceholder: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Placeholder text for search input",
      defaultValue: {
        value: "messages.searchPlaceholder",
        computed: true
      }
    },
    children: {
      type: {
        name: "node"
      },
      required: true,
      description: "Column of any type (e.g. DisplayColumn)"
    },
    expandable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Possibility to make rows expandable",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    multipleRowsExpandable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Multiple rows can be expanded at the same time",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    renderExpanderContent: {
      type: {
        name: "func"
      },
      required: false,
      description: "Content of the expandable rows"
    },
    headerMultiline: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to true header can be on 2 lines",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    onRowClick: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback for row click"
    },
    expandOnRowClick: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Row will expand on click"
    },
    selectOnRowClick: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Row will be selected on click"
    },
    selectionType: {
      type: {
        name: "enum",
        value: [{
          value: "'none'",
          computed: false
        }, {
          value: "'single'",
          computed: false
        }, {
          value: "'multi'",
          computed: false
        }]
      },
      required: false,
      description: "Configures row selection capability (none, single row, multi row)",
      defaultValue: {
        value: "'none'",
        computed: false
      }
    },
    selectedRows: {
      type: {
        name: "arrayOf",
        value: {
          name: "custom",
          raw: "rowIdShape"
        }
      },
      required: false,
      description: "Currently selected rows (passing value for this prop makes component fully controlled)"
    },
    selectionActions: {
      type: {
        name: "arrayOf",
        value: {
          name: "shape",
          value: {
            icon: {
              name: "string",
              required: true
            },
            label: {
              name: "string",
              required: true
            },
            callback: {
              name: "func",
              required: true
            }
          }
        }
      },
      required: false,
      description: "List of actions available for selection"
    },
    onSelectionChange: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback to be invoked when selection changed"
    },
    columnsConfigurable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to false, end user will not have a possibility to customize visibility of columns",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    loadingText: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Text to show while data is loading, by default - 'Loading..'",
      defaultValue: {
        value: "messages.loadingText",
        computed: true
      }
    },
    noDataText: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Text message, when no data present to be shown",
      defaultValue: {
        value: "messages.noDataText",
        computed: true
      }
    },
    localSorting: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to true, sorting is happening locally after data is fetched\nOnly for async mode",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    phone: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any DataTable property to use at 'phone' breakpoint"
    },
    phoneWide: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any DataTable property to use 'phoneWide' and 'phone' breakpoint"
    },
    tablet: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any DataTable property to use at 'tablet', 'phoneWide' and 'phone' breakpoint"
    },
    onSaveRow: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row, rowId) to be invoked when row is saved"
    },
    onEditCancel: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row, rowId) to be invoked when row edit is canceled"
    },
    onEditStart: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row, rowId) to be invoked when row edit is started"
    },
    path: {
      type: {
        name: "string"
      },
      required: false,
      description: "The full path of view model, it also acts as an accessor for datatable's data"
    },
    onFetchData: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback to be invoked when new data has to be fetched in async mode,\nwith one argument of the current state of config object '{ filterValue, sorted, pageSize, page }'.\nShould return a promise of an object '{ rows, numberOfRows }', in which 'rows' is the filtered data to be presented for the current page,\n'numberOfRows' is the total length of whole data.\nIt takes precedence over `data` and `numberOfRows` sync props"
    },
    onGetRowId: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row) that returns unique id for the row.\nThe id should not change after editing the row.\nBy default index from data is used, but it does not work correctly when filtering.",
      defaultValue: {
        value: "(row, index) => index",
        computed: false
      }
    },
    rowIdPath: {
      type: {
        name: "string"
      },
      required: false,
      description: "Name of row object property containing the row id. Takes precedence over onGetRowId prop."
    },
    tableLabel: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Data table aria label",
      defaultValue: {
        value: "messages.tableLabel",
        computed: true
      }
    },
    numberOfRows: {
      type: {
        name: "number"
      },
      required: false,
      description: "Number of available rows"
    }
  }
};